var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.favorites.length
    ? _c("w-select", {
        attrs: {
          value: _vm.selectedId,
          items: _vm.items,
          label: _vm.computedLabel,
          fancy: _vm.fancy,
        },
        on: {
          input: function ($event) {
            return _vm.onInput($event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }